import { MenuItem, FormControl, Select, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ITEM_HEIGHT = 52;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      boxShadow: 0,
      fontFamily: 'Poppins',
    },
  },
};

export default function MultipleSelectCheckmarks({
  selectedClients,
  handleChangeClient,
  clientinfo,
}: any) {
  const allClientsData = {
    clientId: '',
    clientName: 'All clients',
    id: 0,
  };
  const clientinfoWithAllClients = clientinfo
    ? [allClientsData, ...clientinfo]
    : [];

  // Set default value to the first client name
  const defaultValue =
    clientinfoWithAllClients.length > 0
      ? clientinfoWithAllClients[0]
      : selectedClients;

  return (
    <FormControl sx={{ m: 1, width: 150 }}>
      <Select
        labelId='demo-single-checkbox-label'
        id='demo-single-checkbox'
        value={selectedClients.length === 0 ? defaultValue : selectedClients} // Set default value here
        onChange={handleChangeClient}
        renderValue={(selected) => (selected as any)?.clientName}
        MenuProps={MenuProps}
        IconComponent={KeyboardArrowDownIcon}
        sx={{
          display: 'flex',
          width: '150px',
          height: '40px',
          alignItems: 'center',
          borderRadius: '8px',
          background: 'var(--Base-White, #FFF)',
          boxShadow: 'none !important',
          fontFamily: 'Poppins',
          '& .MuiOutlinedInput-notchedOutline': {
            fontSize: '16px',
            fontWeight: 400,
            fontFamily: 'Poppins',
          },
          '& .MuiSelect-outlined': {
            fontSize: '16px',
            fontWeight: 400,
            fontFamily: 'Poppins',
            '@media (max-width: 1440px)': {
              fontSize: '14px',
            },
            '@media (max-width: 1336px)': {
              fontSize: '12px',
            },
          },
          '@media (max-width: 1440px)': {
            height: '30px',
          },
        }}
      >
        {clientinfoWithAllClients?.map((client: any) => (
          <MenuItem
            key={client.clientId}
            value={client}
            sx={{
              borderBottom: '1px solid var(--Gray-200, #EAECF0) !important',
              display: 'flex',
              padding: '8px 12px !important',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '6px',
              background: 'var(--Base-White, #FFF)',
              boxShadow: 'none !important',
              minWidth: '0px !important',
              fontFamily: 'Poppins !important',
            }}
          >
            <Typography
              component={'p'}
              sx={{
                color: '#242424',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '1rem',
                fontFamily: 'Poppins !important',
                width: '100%',
                display: 'flex',
                justifyContent: 'start',
                '@media (max-width: 1440px)': {
                  fontSize: '14px',
                },
                '@media (max-width: 1336px)': {
                  fontSize: '12px',
                },
              }}
            >
              {client.clientName}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
